import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useCallback, useEffect, useMemo } from 'react';

import { useDevTool } from 'shared/ui/CreditSelectionDevTool';

import { mockData } from './useDevFillMockDataTool.constants';

type TMockData = typeof mockData;

type Params = {
  type: keyof TMockData | Array<keyof TMockData>;
  stepLabel: string;
};

// использовать только на dev/stage
export const useDevFillMockDataTool = <Values extends Record<string, unknown>>(params: Params) => {
  const { type, stepLabel } = params;
  const { setValue, trigger } = useFormContext<Values>();
  const devTools = useDevTool();
  const { data, defaultData, toolAddId, toolRemoveId } = useMemo(() => {
    let data = {};
    let defaultData = {};
    let toolAddId = '';
    let toolRemoveId = '';

    if (Array.isArray(type)) {
      type.forEach((t) => {
        const mock = mockData[t] || {};
        data = { ...data, ...(mock.data || {}) };
        defaultData = { ...defaultData, ...(mock.defaultData || {}) };
        toolAddId += `${mock.toolAddId || ''}_`;
        toolRemoveId += `${mock.toolRemoveId || ''}_`;
      });
    } else {
      const mock = mockData[type] || {};
      data = mock.data || {};
      defaultData = mock.defaultData || {};
      toolAddId = mock.toolAddId || '';
      toolRemoveId = mock.toolRemoveId || '';
    }

    return { data, defaultData, toolAddId, toolRemoveId };
  }, [type]);

  const fillData = useCallback(() => {
    Object.keys(data).forEach((key) => {
      setValue(key as never, data[key as keyof typeof data]);
    });
    trigger();
  }, [setValue, trigger, data]);

  const clearData = useCallback(() => {
    Object.keys(defaultData).forEach((key) => {
      setValue(key as never, defaultData[key as keyof typeof defaultData]);
    });
  }, [setValue, defaultData]);

  useEffect(() => {
    if (devTools) {
      const { addTool } = devTools;
      addTool([
        {
          type: 'button',
          label: `Заполнить шаг ${stepLabel}`,
          id: toolAddId,
          onClick: fillData,
        },
        {
          type: 'button',
          label: `Очистить шаг ${stepLabel}`,
          id: toolRemoveId,
          onClick: clearData,
        },
      ]);
    }

    return () => {
      if (devTools) {
        const { removeTool } = devTools;
        removeTool([toolRemoveId, toolAddId]);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
